import React from 'react';

import AdditionalMessage from '../../Feedback/AdditionalMessage/index.tsx';
import type { ErrorProps, ErrorRenderer } from '../Error/index.tsx';
import Error from '../Error/index.tsx';
import Label from '../Label/index.tsx';
import { FieldPlaceholder } from './styled.ts';

export interface FormFieldPropsBase extends React.PropsWithChildren {
  label?: string;
  labelTooltip?: React.ReactNode;
  required?: boolean;
  disabled?: boolean;
  renderError?: ErrorRenderer;
  withTouched?: boolean;
  dataTestId?: string;
  warningMessage?: string;
  fieldPlaceholder?: React.ReactNode;
}

export interface FormFieldProps<TName extends string = string> extends ErrorProps<TName>, FormFieldPropsBase {}

const FormField = <TName extends string = string>({
  children,
  disabled,
  label,
  labelTooltip,
  name,
  required,
  error,
  formatMessage,
  submitError,
  touched,
  withTouched,
  renderError,
  dataTestId,
  warningMessage,
  fieldPlaceholder,
}: FormFieldProps<TName>) => (
  <>
    {label && (
      <Label disabled={disabled} required={required} tooltip={labelTooltip} dataTestId={dataTestId}>
        {label}
      </Label>
    )}
    {fieldPlaceholder ? <FieldPlaceholder>{fieldPlaceholder}</FieldPlaceholder> : children}
    {warningMessage && !error && <AdditionalMessage message={warningMessage} />}
    <Error
      name={name}
      touched={touched}
      error={error}
      submitError={submitError}
      formatMessage={formatMessage}
      withTouched={withTouched}
      renderError={renderError}
    />
  </>
);

export default React.memo(FormField) as typeof FormField;
